import { Component, Injector, OnInit } from '@angular/core';
import { DaoBaseService } from 'src/app/dao/dao-base.service';
import { AtividadeDaoService } from 'src/app/dao/atividade-dao.service';
import { AtividadeTarefaDaoService } from 'src/app/dao/atividade-tarefa-dao.service';
import { DocumentoDaoService } from 'src/app/dao/documento-dao-service';
import { EntidadeDaoService } from 'src/app/dao/entidade-dao.service';
import { PlanoTrabalhoDaoService } from 'src/app/dao/plano-trabalho-dao.service';
import { TipoDocumentoDaoService } from 'src/app/dao/tipo-documento-dao.service';
import { Base, IIndexable } from 'src/app/models/base.model';
import { AtividadeTarefa } from 'src/app/models/atividade-tarefa.model';
import { Documento } from 'src/app/models/documento.model';
import { PlanoTrabalhoListComponent } from 'src/app/modules/gestao/plano-trabalho/plano-trabalho-list/plano-trabalho-list.component';
import { AtividadeListGridComponent } from 'src/app/modules/gestao/atividade/atividade-list-grid/atividade-list-grid.component';
import { AtividadeListComponent } from 'src/app/modules/gestao/atividade/atividade-list/atividade-list.component';
import { ListenerBase } from '../listener-base';
import { ListenerAllPagesService } from '../listener-all-pages.service';
import { MenuItem } from 'src/app/app.component';
import { ToolbarButton } from 'src/app/components/toolbar/toolbar.component';
import { EntityService } from 'src/app/services/entity.service';

@Component({
  selector: 'app-procedimento-trabalhar',
  templateUrl: './procedimento-trabalhar.component.html',
  styleUrls: ['./procedimento-trabalhar.component.scss']
})
export class ProcedimentoTrabalharComponent extends ListenerBase {

  public tipoDocumentoDao: TipoDocumentoDaoService;
  public allPages: ListenerAllPagesService;
  public entityService: EntityService;
  public dao: EntidadeDaoService;
  public buttons: {[id: string]: ToolbarButton} = {
    TESTE: {
      id: "TESTE",
      icon: "bi bi-apple text-danger",
      color: "btn-outline-danger",
      hint: "Petrvs: Teste",
      onClick: this.testeApiSei.bind(this) 
    },
    /*TCR: {
      id: "TCR",
      icon: "bi bi-list-check text-primary",
      color: "btn-outline-primary",
      hint: "Gerar termo de adesão",
      onClick: this.gerarTermoAdesao.bind(this) 
    },*/
    ATIVIDADES: {
      id: "ATIVIDADES",
      color: "btn-outline-success",
      hint: "Petrvs: " + this.lex.translate("Atividades"),
      onClick: this.atividades.bind(this),
    },
    ATIVIDADE_INCLUIR: {
      id: "ATIVIDADE_INCLUIR",
      iconBadge: "bi bi-plus-circle text-success",
      color: "btn-outline-primary",
      label: "Petrvs: Incluir " + this.lex.translate("atividade"),
      onClick: this.incluirAtividade.bind(this)
    },
    ATIVIDADE_CONCLUIR: {
      id: "ATIVIDADE_CONCLUIR",
      iconBadge: "bi bi-check-circle text-success",
      color: "btn-outline-primary",
      label: "Petrvs: Concluir " + this.lex.translate("atividade"),
      onClick: this.concluirAtividade.bind(this)
    },
    TAREFA_CONCLUIR: {
      id: "TAREFA_CONCLUIR",
      iconBadge: "bi bi-check-circle text-success",
      color: "btn-outline-primary",
      label: "Petrvs: Concluir " + this.lex.translate("tarefa"),
      onClick: this.concluirTarefa.bind(this)
    },
    TAREFA_INCLUIR: {
      id: "TAREFA_INCLUIR",
      iconBadge: "bi bi-plus-circle text-success",
      color: "btn-outline-secondary",
      hint: "Petrvs: Incluir " + this.lex.translate("tarefa"),
      onClick: this.incluirTarefa.bind(this),
    },
    ATUALIZAR_TIPOS_DOCUMENTOS: {
      id: "ATUALIZAR_TIPOS_DOCUMENTOS",
      iconBadge: "bi bi-arrow-repeat text-success",
      color: "btn-outline-warning",
      hint: "Petrvs: Atualizar " + this.lex.translate("tipos de documentos"),
      onClick: this.atualizarTiposDocumentos.bind(this)
    }
  };

  constructor(public injector: Injector) {
    super(injector, "procedimento_trabalhar");
    this.dao = injector.get<EntidadeDaoService>(EntidadeDaoService);
    this.tipoDocumentoDao = injector.get<TipoDocumentoDaoService>(TipoDocumentoDaoService);
    this.allPages = injector.get<ListenerAllPagesService>(ListenerAllPagesService);
    this.entityService = injector.get<EntityService>(EntityService);
    this.buttons.ATIVIDADES.icon = this.entityService.getIcon("Atividade") + " text-success";
    this.buttons.ATIVIDADE_INCLUIR.icon = this.entityService.getIcon("Atividade") + " text-success";
    this.buttons.ATIVIDADE_CONCLUIR.icon = this.entityService.getIcon("Atividade") + " text-success";
    this.buttons.TAREFA_CONCLUIR.icon = this.entityService.getIcon("Tarefa") + " text-secondary";
    this.buttons.TAREFA_INCLUIR.icon = this.entityService.getIcon("Tarefa") + " text-secondary";
    this.buttons.ATUALIZAR_TIPOS_DOCUMENTOS.icon = this.entityService.getIcon("TipoDocumento") + " text-warning";
    console.log("Listner: procedimento-trabalhar");
  }

  public async loadToolbarButtons(buttons: string[]) {
    let toolbarButtons: ToolbarButton[] = [];
    /* Atividades */
    if (buttons.find(x => ["ATIVIDADES", "ATIVIDADE_INCLUIR", "ATIVIDADE_CONCLUIR"].includes(x))) {
      let menu = [];
      if (buttons.includes("ATIVIDADE_INCLUIR")) menu.push(this.buttons.ATIVIDADE_INCLUIR);
      if (buttons.includes("ATIVIDADE_CONCLUIR")) menu.push(this.buttons.ATIVIDADE_CONCLUIR);
      toolbarButtons.push(Object.assign({}, this.buttons.ATIVIDADES, { items: menu.length ? menu : undefined }));
    }
    /* Tarefas */
    if (buttons.find(x => ["TAREFA_INCLUIR", "TAREFA_CONCLUIR"].includes(x))) {
      let menu = [];
      if (buttons.includes("TAREFA_CONCLUIR")) menu.push(this.buttons.TAREFA_CONCLUIR);
      toolbarButtons.push(Object.assign({}, this.buttons.TAREFA_INCLUIR, { items: menu.length ? menu : undefined }));
    }
    if (buttons.includes("ATUALIZAR_TIPOS_DOCUMENTOS")) toolbarButtons.push(this.buttons.ATUALIZAR_TIPOS_DOCUMENTOS);
    this.gb.toolbarButtons = toolbarButtons;
    let seiButtons = buttons.map(x => {
      return {
        id: this.buttons[x].id,
        icon: this.buttons[x].icon,
        iconBadge: this.buttons[x].iconBadge,
        label: this.buttons[x].label || this.buttons[x].hint,
      };
    });
    //await this.allPages.carregarMenuLateral(this.gb.app?.modulo);
    await this.execute<void>("addSeiToolbarButton", [seiButtons]);
  }

  public async toolbarButtonClick(id: string) {
    await this.buttons[id]?.onClick!();
  }

  public async testeApiSei() {
    let response = await this.allPages.ajax("dados_documento", { numero: "0000003" });
    console.log(response);
  }

  public async atividades() {
    let keys = await this.allPages.getProcessoKeys();
    if (keys) this.go.navigate({ route: ["gestao", "atividade"], params: { filter: { numero_processo: keys.numero_processo } } }, { modal: true, modalWidth: 1200 });
  }

  public async incluirAtividade() {
    let keys = await this.allPages.getSeiKeys();
    if (keys) this.go.navigate({ route: ["gestao", "atividade", "new"] }, { metadata: { sei: keys }, modal: true });
  }

  public async concluirAtividade() {
    let keys = await this.allPages.getDocumentoKeys();
    if (keys) {
      const selected = await AtividadeListGridComponent.modalSelect({ fixedFilter: [["status", "==", "INICIADO"]] });
      if (selected) {
        if (selected.metadados?.pausado) {
          if (await this.dialog.confirm("Atividade pausada", "Para concluir é necessário primeiro reiniciar a atividade. Deseja reiniciar?")) {
            this.go.navigate({ route: ['gestao', 'atividade', selected.id, 'pausar'], params: { reiniciar: true } }, {
              modal: true,
              modalClose: (modalResult?: string) => {
                if (modalResult?.length) this.go.navigate({ route: ['gestao', 'atividade', selected.id, 'concluir'] }, { modal: true });
              }
            });
          }
        } else {
          this.go.navigate({ route: ['gestao', 'atividade', selected.id, 'concluir'] }, { modal: true });
        }
      }
    }
  }

  public async concluirTarefa() {
    let keys = await this.allPages.getProcessoKeys();
    if (keys) {
      this.go.navigate({ route: ['gestao', 'atividade', 'tarefa', 'concluir'], params: { id_processo: keys.id_processo } }, { modal: true });
    }
  }

  public async incluirTarefa() {
    let keys = await this.allPages.getSeiKeys();
    if (keys) {
      const selected = await AtividadeListGridComponent.modalSelect({ fixedFilter: [["status", "==", "NAOCONCLUIDO"]] });
      if (selected) {
        const tarefa = new AtividadeTarefa();
        tarefa.id = this.dao.generateUuid();
        tarefa.usuario = this.auth.usuario;
        tarefa.usuario_id = this.auth.usuario!.id;
        tarefa.atividade_id = selected.id || "";
        tarefa.comentarios = [];
        tarefa._status = "ADD";
        this.go.navigate({ route: ['gestao', 'atividade', 'tarefa'] }, {
          metadata: { tarefa: tarefa, atividade: selected, sei: keys }, modalClose: (modalResult) => {
            if (modalResult) {
              (async () => {
                try {
                  const dao = this.injector.get<AtividadeTarefaDaoService>(AtividadeTarefaDaoService);
                  this.dialog.showSppinerOverlay("Salvando dados do formulário");
                  await dao.save(modalResult);
                } catch (error: any) {
                  this.dialog.alert("Error", error.message ? error.message : error);
                } finally {
                  this.dialog.closeSppinerOverlay();
                }
              })();
            }
          }
        });
      }
    }
  }

  public async atualizarTiposDocumentos() {
    let tiposDocumentos = await this.allPages.getTiposDocumentos();
    if (await this.tipoDocumentoDao.atualizar(tiposDocumentos)) {
      this.dialog.alert("Atualização", "Atualização realizada com sucesso!");
    } else {
      this.dialog.alert("ERROR", "Aconteceu algum problema ao tentar realizar a atualização!");
    }
  }

}
